import { InlineStack, Link, Text } from "@shopify/polaris";
import React from "react";
import type { ReactElement } from 'react';
import { useTranslation } from "react-i18next";
export function Menu() {
  const { t } = useTranslation();
  let m: MenuObj[] = [
    {
      url: '/dashboard',
      label: t('overview'),
      path: 'dashboard',
      heading: t('overview'),
      showTargetSelect: true,
      showPage: false,
      page_description: t("Hey there! Dive into the most crucial updates of your Products, Orders, and latest activities in your account."),
      footerUrl: 'https://support.cedcommerce.com/portal/en/kb/articles/overview-26-3-2024'
    },
    {
      url: 'dashboard/pricing',
      label: t('subscription_plan'),
      hidden: true,
      showTargetSelect: true,
      path: 'dashboard/pricing',
      heading: t('subscription_plan'),
    },
    // {
    //     url: '/localselling',
    //     label: t('local_selling'),
    //     path: 'localselling',
    //     hidden: true,
    //     heading: t('local_selling'),
    //     page_description: t('local_selling_header_desc'),
    // },
    {
      url: '/product',
      label: t('listings'),
      path: 'product',
      hidden: false,
      showPage: true,
      fullscreen: true,
      showTargetSelect: true,
      heading: t('listings'),
      page_description: t('This section allows you to easily control all your Amazon listings. You can check your listing statuses, perform actions on multiple products at once, leverage Sync Status and Amazon Lookup, etc.'),
      footerUrl: 'https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=listings-3'
    },
    {
      url: '/productlinkings',
      label: t('product_linking'),
      showPage: true,
      fullscreen: true,
      showTargetSelect: true,
      path: 'productlinkings',
      heading: t('link_amazon_products'),
      page_description: (
        <InlineStack gap={"050"}>
          <Text as='p'>{t('Link your Amazon listings to the correct Shopify products. Review matches, fix incorrect links, and manually connect products that need attention for accurate syncing. Head here to ')}</Text>
          <Link target="_blank" url="https://support.cedcommerce.com/portal/en/kb/articles/product-linking-26-3-2024-1">know more.</Link>
        </InlineStack>
      ),

      footerUrl: 'https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=amazon-product-linking'
    },
    {
      url: '/template/:t_id',
      label: t('edit_template'),
      breadcrum: -1,
      path: 'template/:t_id',
      heading: t('edit_template'),
      hidden: true,
      page_description: t('Save time and reduce redundancy when uploading products by setting templates. Predefine metrics like Inventory and Price, and apply them as defaults across your products. These templates enable streamlined management and updates for multiple products simultaneously, allowing you to address Inventory Settings, Price Settings, Mapping Attributes, and more across all listings in a single go.'),
    },
    {
      url: '/config',
      label: t('settings'),
      showPage: true,
      showTargetSelect: true,
      path: 'config',
      heading: t('settings'),
      page_description: t('Enhance your workflow efficiency and operational effectiveness by connecting multiple accounts, customizing product, and order settings, and creating templates for easier product data management.'),
      footerUrl: 'https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=settings-35'
    },
    {
      url: '/config/accounts',
      label: t('settings'),
      hidden: true,
      showPage: true,
      showTargetSelect: true,
      path: 'config/accounts',
      heading: t('settings'),
      page_description: t('Enhance your workflow efficiency and operational effectiveness by connecting multiple accounts, customizing product, and order settings, and creating templates for easier product data management.'),
      footerUrl: 'https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=accountsioy98y9'
    },
    {
      url: '/config/notifications',
      label: t('settings'),
      hidden: true,
      showPage: true,
      showTargetSelect: true,
      path: 'config/notifications',
      heading: t('settings'),
      page_description: t('Enhance your workflow efficiency and operational effectiveness by connecting multiple accounts, customizing product, and order settings, and creating templates for easier product data management.'),
      footerUrl: 'https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=notifications0987'
    },
    {
      url: '/config/productSettings',
      label: t('settings'),
      hidden: true,
      showPage: true,
      showTargetSelect: true,
      path: 'config/productSettings',
      heading: t('settings'),
      page_description: t('Enhance your workflow efficiency and operational effectiveness by connecting multiple accounts, customizing product, and order settings, and creating templates for easier product data management.'),
      footerUrl: 'https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=product-settings-7password1'
    },
    {
      url: '/config/productSettings/inventory',
      label: t('settings'),
      hidden: true,
      showPage: true,
      showTargetSelect: true,
      path: 'config/productSettings/inventory',
      heading: t('settings'),
      page_description: t('Enhance your workflow efficiency and operational effectiveness by connecting multiple accounts, customizing product, and order settings, and creating templates for easier product data management.'),
      footerUrl: 'https://support.cedcommerce.com/portal/en/kb/articles/inventory'
    },
    {
      url: '/config/productSettings/price',
      label: t('settings'),
      hidden: true,
      showPage: true,
      showTargetSelect: true,
      path: 'config/productSettings/price',
      heading: t('settings'),
      page_description: t('Enhance your workflow efficiency and operational effectiveness by connecting multiple accounts, customizing product, and order settings, and creating templates for easier product data management.'),
      footerUrl: 'https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=price-0987'
    },
    {
      url: '/config/productSettings/product',
      label: t('settings'),
      hidden: true,
      showPage: true,
      showTargetSelect: true,
      path: 'config/productSettings/product',
      heading: t('settings'),
      page_description: t('Enhance your workflow efficiency and operational effectiveness by connecting multiple accounts, customizing product, and order settings, and creating templates for easier product data management.'),
      footerUrl: 'https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=product-details-09876'
    },
    {
      url: '/config/productSettings/global_price',
      label: t('settings'),
      hidden: true,
      showPage: true,
      showTargetSelect: true,
      path: 'config/productSettings/global_price',
      heading: t('settings'),
      page_description: t('Enhance your workflow efficiency and operational effectiveness by connecting multiple accounts, customizing product, and order settings, and creating templates for easier product data management.'),
      footerUrl: 'https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=global-price-adjustment-a-currency-conversion-tool'
    },
    {
      url: '/config/orderSettings',
      label: t('settings'),
      hidden: true,
      showPage: true,
      showTargetSelect: true,
      path: 'config/orderSettings',
      heading: t('settings'),
      page_description: t('Enhance your workflow efficiency and operational effectiveness by connecting multiple accounts, customizing product, and order settings, and creating templates for easier product data management.'),
      footerUrl: 'https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=order_settings'
    },
    {
      url: '/config/orderSettings/order',
      label: t('settings'),
      hidden: true,
      showPage: true,
      showTargetSelect: true,
      path: 'config/orderSettings/order',
      heading: t('settings'),
      page_description: t('Enhance your workflow efficiency and operational effectiveness by connecting multiple accounts, customizing product, and order settings, and creating templates for easier product data management.'),
      footerUrl: 'https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=orders0987654'
    },
    {
      url: '/config/orderSettings/shipment',
      label: t('settings'),
      hidden: true,
      showPage: true,
      showTargetSelect: true,
      path: 'config/orderSettings/shipment',
      heading: t('settings'),
      page_description: t('Enhance your workflow efficiency and operational effectiveness by connecting multiple accounts, customizing product, and order settings, and creating templates for easier product data management.'),
      footerUrl: 'https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=shipment123456'
    },
    {
      url: '/config/orderSettings/cancelRefund',
      label: t('settings'),
      hidden: true,
      showPage: true,
      showTargetSelect: true,
      path: 'config/orderSettings/cancelRefund',
      heading: t('settings'),
      page_description: t('Enhance your workflow efficiency and operational effectiveness by connecting multiple accounts, customizing product, and order settings, and creating templates for easier product data management.'),
      footerUrl: "https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=cancellation-and-refund9876"
    },
    {
      url: '/config/orderSettings/refundOrder',
      label: t('settings'),
      hidden: true,
      showPage: true,
      showTargetSelect: true,
      path: 'config/orderSettings/refundOrder',
      heading: t('settings'),
      page_description: t('Enhance your workflow efficiency and operational effectiveness by connecting multiple accounts, customizing product, and order settings, and creating templates for easier product data management.'),
      footerUrl: "https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=cancellation-and-refund9876"
    },
    {
      url: '/config/orderSettings/mcf',
      label: t('settings'),
      hidden: true,
      showPage: true,
      showTargetSelect: true,
      path: 'config/orderSettings/mcf',
      heading: t('settings'),
      page_description: t('Enhance your workflow efficiency and operational effectiveness by connecting multiple accounts, customizing product, and order settings, and creating templates for easier product data management.'),
    },
    {
      url: '/config/templateSettings/new',
      label: t('settings'),
      hidden: true,
      showPage: true,
      showTargetSelect: true,
      path: 'config/templateSettings/new',
      heading: t('settings'),
      page_description: t('Enhance your workflow efficiency and operational effectiveness by connecting multiple accounts, customizing product, and order settings, and creating templates for easier product data management.'),
      footerUrl: 'https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=product-templates-2'
    },
    {
      url: '/config/sandbox',
      label: t('settings'),
      hidden: true,
      showPage: true,
      showTargetSelect: true,
      path: 'config/sandbox',
      heading: t('settings'),
      page_description: t('Enhance your workflow efficiency and operational effectiveness by connecting multiple accounts, customizing product, and order settings, and creating templates for easier product data management.'),
      footerUrl: 'https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=notifications0987'
    },
    {
      url: '/config/templateSettings',
      label: 'Settings',
      hidden: true,
      showPage: true,
      showTargetSelect: true,
      path: 'config/templateSettings',
      heading: 'Settings',
      page_description: 'Simplify your workflow and optimize your operations with connecting multiple accounts, customizing product and order settings, and creating templates to streamline your product data management. ',
      footerUrl: 'https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=product-templates-2'
    },
    {
      url: '/config/templateSettings/offer',
      label: t('settings'),
      hidden: true,
      showPage: true,
      showTargetSelect: true,
      path: 'config/templateSettings/offer',
      heading: t('settings'),
      page_description: t('Enhance your workflow efficiency and operational effectiveness by connecting multiple accounts, customizing product, and order settings, and creating templates for easier product data management.'),
    },
    // {
    //     url: '/config/localSelling',
    //     label: t('settings'),
    //     hidden: true,
    //     showPage: true,
    //     showTargetSelect: true,
    //     path: 'config/localSelling',
    //     heading: t('settings'),
    //     page_description: t('Enhance your workflow efficiency and operational effectiveness by connecting multiple accounts, customizing product, and order settings, and creating templates for easier product data management.'),
    //     footerUrl: 'https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=what-is-amazon-local-selling'
    // },
    // {
    //     url: '/config/localSelling/bopis',
    //     label: t('settings'),
    //     hidden: true,
    //     showPage: true,
    //     showTargetSelect: true,
    //     path: 'config/localSelling/bopis',
    //     heading: t('settings'),
    //     page_description: t('Enhance your workflow efficiency and operational effectiveness by connecting multiple accounts, customizing product, and order settings, and creating templates for easier product data management.'),
    //     footerUrl: 'https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=what-is-amazon-local-selling'
    // },
    // {
    //     url: '/config/localSelling/bopis_sync',
    //     label: t('settings'),
    //     hidden: true,
    //     showPage: true,
    //     showTargetSelect: true,
    //     path: 'config/localSelling/bopis_sync',
    //     heading: t('settings'),
    //     page_description: t('Enhance your workflow efficiency and operational effectiveness by connecting multiple accounts, customizing product, and order settings, and creating templates for easier product data management.'),
    // },
    {
      url: '/allSales',
      label: t('Orders'),
      path: 'allSales',
      hidden: false,
      showPage: true,
      fullscreen: true,
      showTargetSelect: true,
      heading: t('Orders'),
      page_description: t('orders_header_desc'),
    },
    {
      url: 'valuemappingupdated',
      label: t('value_mapping'),
      hidden: true,
      showPage: true,
      showTargetSelect: true,
      page_description: t('value_mapping_desc'),
      path: 'valuemappingupdated',
      heading: t('value_mapping'),
      footerUrl: ''
    },
    {
      url: '/refundOrders',
      label: t('failed_refund_orders'),
      hidden: true,
      showPage: true,
      showTargetSelect: true,
      page_description: t('failed_refund_orders_header_desc'),
      path: 'refundOrders',
      heading: t('failed_refund_orders'),
      breadcrum: -1,
      footerUrl: 'https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=refund_orders'
    },
    {
      url: '/unshippedOrders',
      label: t('Unshipped Orders'),
      hidden: true,
      showPage: true,
      showTargetSelect: true,
      page_description: t('Unshipped Orders description'),
      path: 'unshippedOrders',
      heading: t('Unshipped Orders'),
      breadcrum: -1,
    },
    {
      url: '/cancelledOrders',
      label: t('failed_canceled_orders'),
      hidden: true,
      showPage: true,
      showTargetSelect: true,
      page_description: t('failed_cancelled_orders_header_desc'),
      path: 'cancelledOrders',
      heading: t('failed_canceled_orders'),
      breadcrum: -1,
      footerUrl: 'https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=cancel-orders-3'
    },
    {
      url: '/faq',
      label: t('FAQs'),
      showPage: true,
      showTargetSelect: true,
      show_only_lng_switcher: true,
      path: 'faq',
      heading: t('faq_header'),
      page_description: t('faq_header_desc'),
      footerUrl: 'https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=_faqs'
    },
    {
      url: '/feeds',
      label: t('feeds'),
      showPage: true,
      fullscreen: true,
      showTargetSelect: true,
      path: 'feeds',
      heading: t('feeds'),
      page_description: t('feeds_section'),
    },
    {
      url: '/failed-order',
      label: t('all_orders'),
      showTargetSelect: true,
      path: 'failed-order/failed',
      heading: t('Orders'),
      page_description: t('all_orders_header_desc'),
    },
    {
      url: '/archived-order',
      label: t('archived_orders'),
      showTargetSelect: true,
      hidden: true,
      path: 'archived-order',
      breadcrum: -1,
      heading: t('archived_orders'),
      page_description: t('archived_orders_header_desc'),
    },
    {
      url: '/view-order',
      label: t('view_orders'),
      showTargetSelect: true,
      path: 'view-order',
      breadcrum: -1,
      hidden: true,
      showPage: false,
      heading: t('view_orders'),
      page_description: t('view_your_order'),
    },
    {
      url: 'dashboard/activity',
      label: t('activities'),
      hidden: true,
      showPage: true,
      showTargetSelect: true,
      breadcrum: -1,
      page_description: t('activities_header_desc'),
      path: 'dashboard/activity',
      heading: t('activities'),
      footerUrl: 'https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=_activity'
    },
    {
      url: 'home/activity',
      label: t('activities'),
      hidden: true,
      showPage: true,
      showTargetSelect: true,
      breadcrum: -1,
      page_description: t('activities_header_desc'),
      path: 'home/activity',
      heading: t('activities'),
      footerUrl: 'https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=_activity'
    },
    {
      url: 'dashboard/activity/import',
      label: t('New Products Import'),
      hidden: true,
      showPage: true,
      showTargetSelect: true,
      breadcrum: -1,
      page_description: t('New products are currently being imported from Shopify into the CedCommerce app and you can see them featured below. If the process encounters any delays, please reach out to our customer support for assistance.'),
      path: 'dashboard/activity/import',
      heading: t('New Products Import'),
      footerUrl: 'https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=_activity'
    },
    {
      url: 'support',
      label: t('support'),
      hidden: true,
      showPage: true,
      fullscreen: true,
      showTargetSelect: true,
      breadcrum: -1,
      page_description: t('support_header_desc'),
      path: 'support',
      heading: t('support_header'),
      footerUrl: 'https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=get-support'
    },
    {
      url: '/knowledgeBase',
      label: t('knowledge_base'),
      path: 'knowledgeBase',
      heading: t('knowledge_base'),
      page_description: t('knowledge_base_header_desc'),
    },
    {
      url: '/staff',
      label: 'Staff User Management',
      path: 'staff',
      showPage: true,
      showTargetSelect: true,
      heading: 'Staff User Management',
      page_description:
        'Admins can authorize new staff requests for accessing the app, ensuring that only authorized personnel are granted access.',
    },
    {
      url: '/config/staffManagement',
      label: 'Settings',
      hidden: true,
      showPage: true,
      showTargetSelect: true,
      path: 'config/staffManagement',
      heading: t('settings'),
      page_description: t('Enhance your workflow efficiency and operational effectiveness by connecting multiple accounts, customizing product, and order settings, and creating templates for easier product data management.'),
      // footerUrl: 'https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=product-templates-2'
    },
    {
      url: '/bda',
      label: 'BDA Panel',
      path: 'bda',
      showPage: true,
      showTargetSelect: true,
      heading: 'BDA Panel',
      page_description:
        'BDA are able to check project related data',
    },
  ]
  return { Navs: m };
};

export interface MenuObj {
  url: string;
  label: string;
  path: string;
  heading: string;
  hidden?: boolean;
  page_description?: string | ReactElement;
  breadcrum?: string | -1 | boolean;
  showTargetSelect?: boolean;
  show_only_lng_switcher?: boolean;
  showPage?: boolean;
  fullscreen?: boolean;
  footerUrl?: string
}
